module.exports = __webpack_public_path__ + "static/img/stay-option-icon-wifi.197c3761.svg";